import PropTypes from 'prop-types';
// material
import { alpha, styled } from '@mui/material/styles';
import {
  Box,
  Stack,
  BottomNavigation,
  Typography,
  Link,
  Grid
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled('div')(({ theme }) => ({
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
  color: theme.palette.primary.main
}));

const FooterBarStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-around',
  alignItems: 'center',
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}));

const LinkBoxStyle = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 20
}));

HeaderOnlyFooter.propTypes = {};

export default function HeaderOnlyFooter() {
  return (
    <RootStyle>
      <FooterBarStyle>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Typography variant="body1" gutterBottom>
              <span>&#169;</span> 2022 <b>Diplomade</b> All right reserved
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <LinkBoxStyle>
              <Link
                component={RouterLink}
                underline="none"
                to={{
                  pathname: ''
                }}
              >
                Privacy Policy
              </Link>
              <Link
                component={RouterLink}
                underline="none"
                to={{
                  pathname: ''
                }}
              >
                Contact
              </Link>
              <Link
                component={RouterLink}
                underline="none"
                to={{
                  pathname: ''
                }}
              >
                Support
              </Link>
            </LinkBoxStyle>
          </Grid>
        </Grid>
      </FooterBarStyle>
    </RootStyle>
  );
}
